import React from 'react';

const ToolCard = ({ tool }) => {
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(<span key={i}>⭐</span>);
      } else if (i === fullStars && hasHalfStar) {
        stars.push(<span key={i}>✨</span>);
      } else {
        stars.push(<span key={i}>☆</span>);
      }
    }
    return stars;
  };

  return (
    <div style={styles.card}>
      <div style={styles.cardHeader}>
        <h3 style={styles.toolName}>{tool.name}</h3>
        <div style={styles.rating}>
          <span style={styles.ratingStars}>{renderStars(tool.rating)}</span>
          <span style={styles.ratingText}>{tool.rating}</span>
        </div>
      </div>

      <p style={styles.description}>{tool.description}</p>

      <div style={styles.priceSection}>
        <span style={styles.priceLabel}>Pricing:</span>
        <span style={styles.price}>{tool.startingPrice}</span>
      </div>

      <div style={styles.channelsSection}>
        <p style={styles.channelsLabel}>Featured on:</p>
        <div style={styles.channelsList}>
          {tool.topYouTubeChannels.slice(0, 3).map((channel, index) => (
            <span key={index} style={styles.channelBadge}>
              {channel}
            </span>
          ))}
          {tool.topYouTubeChannels.length > 3 && (
            <span style={styles.channelBadge}>
              +{tool.topYouTubeChannels.length - 3} more
            </span>
          )}
        </div>
      </div>

      <a
        href={tool.redirectLink}
        target="_blank"
        rel="noopener noreferrer"
        style={styles.learnMoreBtn}
      >
        Learn More →
      </a>
    </div>
  );
};

const styles = {
  card: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    transition: 'transform 0.3s, box-shadow 0.3s',
    cursor: 'pointer',
    border: '1px solid #e0e0e0',
    height: '100%',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '10px',
  },
  toolName: {
    margin: '0 0 0 0',
    fontSize: '1.2rem',
    color: '#2c3e50',
    fontWeight: '600',
    wordBreak: 'break-word',
  },
  rating: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    whiteSpace: 'nowrap',
  },
  ratingStars: {
    fontSize: '0.9rem',
    letterSpacing: '2px',
  },
  ratingText: {
    fontSize: '0.85rem',
    color: '#7f8c8d',
    fontWeight: '500',
  },
  description: {
    margin: '0',
    fontSize: '0.95rem',
    color: '#555',
    lineHeight: '1.5',
    wordWrap: 'break-word',
  },
  priceSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 12px',
    backgroundColor: '#f0f4ff',
    borderRadius: '6px',
    borderLeft: '3px solid #3498db',
  },
  priceLabel: {
    fontSize: '0.9rem',
    fontWeight: '600',
    color: '#2c3e50',
  },
  price: {
    fontSize: '0.9rem',
    color: '#3498db',
    fontWeight: '500',
  },
  channelsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  channelsLabel: {
    margin: '0',
    fontSize: '0.85rem',
    fontWeight: '600',
    color: '#2c3e50',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  channelsList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
  },
  channelBadge: {
    display: 'inline-block',
    padding: '4px 10px',
    backgroundColor: '#e3f2fd',
    color: '#0066cc',
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: '500',
    wordBreak: 'break-word',
  },
  learnMoreBtn: {
    display: 'inline-block',
    padding: '10px 16px',
    backgroundColor: '#3498db',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '6px',
    fontSize: '0.95rem',
    fontWeight: '600',
    textAlign: 'center',
    transition: 'background-color 0.3s',
    marginTop: '10px',
    alignSelf: 'flex-start',
  },
};

export default ToolCard;
